export type UnpackedApiError = {
  detail?: string;
  code?: string;
};

const unpackApiError = async (response: Response): Promise<UnpackedApiError> => {
  type MaybeError = {
    code?: {
      general?: string[];
    };
    detail?: string;
  };

  let error: MaybeError = {};
  try {
    // Attempt to unpack the body
    error = await response.json();
  } catch (e) {
    // If it's a 500ish status, we're not going to have a body, so this error will throw
    return {
      detail: 'There was problem with submitting the form.',
    };
  }
  // If there was something in the detail key is going to have our error.
  // We'll also provide the code, which can be used in other processing.
  const errorDetails: UnpackedApiError = {
    detail: error?.detail,
  };
  if (error?.code?.general?.[0]) {
    errorDetails.code = error?.code?.general?.[0];
  } else if (typeof error?.code === 'string') {
    errorDetails.code = error.code;
  }
  return errorDetails;
};

export default unpackApiError;
